import AlertBarBrowseOnly from './AlertBarBrowseOnly'

export default AlertBarBrowseOnly
// eslint-disable-next-line import/export
export * from './AlertBarBrowseOnly'
